import axios from '@/libs/axios'

export default {
    state: {
        prod: 'getProduits',
        fromList: false,
        produit: {},
        risque: {},
        produits: []
    },
    mutations: {
        setProduit(state, paylaod) {
            state.produit = paylaod.produit
        },
        setRisque(state, paylaod) {
            state.risque = paylaod.risque
        },
        setProd(state, paylaod) {
            state.prod = paylaod.prod
        },
        setProduits(state, produits) {
            state.produits = produits
        },
        setFromList(state, paylaod) {
            state.fromList = paylaod
        }
    },
    actions: {
        getAllProduits({
            commit
        }) {
            axios
                .get(`produit/getAllProduits`)
                .then(response => {
                    commit("setProduits", response.data)
                })
                .catch(error => console.log(error))
        }
    },
    getters: {
        getProduit(state) {
            return state.produit
        },
        getRisque(state) {
            return state.risque
        },
        getProd(state) {
            return state.prod
        },
        getProduits(state) {
            return state.produits
        },
        getFromList(state) {
            return state.fromList
        },
    },
}
